import { AutocompletePrediction, ShippingAddress } from "../types";
import { patientApi } from "./patientApi";

export const placesApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    addressAutocomplete: builder.query<AutocompletePrediction[], string>({
      query: (input: string) => ({
        method: "GET",
        url: `/api/places`,
        params: {
          input,
        },
      }),
    }),
    getAddressDetails: builder.query<ShippingAddress, string>({
      query: (placeId: string) => ({
        method: "GET",
        url: `/api/places/${placeId}`,
      }),
    }),
  }),
});

export const {
  useAddressAutocompleteQuery,
  useGetAddressDetailsQuery,
  useLazyGetAddressDetailsQuery,
} = placesApi;
